/* eslint-disable camelcase */
import {  useState } from "react";
import { Nav, NavDropdown } from "react-bootstrap";
import { useNavigate,useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearModalContent } from "src/redux/modules/modalEvent";
import Avatar from "src/components/base/Avatar/Avatar";
import { Weight } from "src/types";
import { Typography } from "src/latest/src/components";


type Props = {
    onLogout: (reason: string) => void;
    textWeight?: Weight;
};

export const ProfileAvatarDropdown = ({ textWeight, onLogout }: Props) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const { loggedInUser } = useSelector(
        ({ authentication }: any) => authentication
    );
  
    const { userRole, full_name, id, user_type } = loggedInUser;
    const [dropdownToggle, setDropdownToggle] = useState(false);

    // TODO: Remove this unused code after testing
    // const [avatarTimestamp, setAvatarTimestamp] = useState<any>(Date.now());

    const isCalendarEnable = useSelector(
        (state: any) => state?.configuration?.isCalendarEnable
    );

    // TODO: Remove this unused code after testing
    // useEffect(() => {
    //     setAvatarTimestamp(Date.now());
    // }, [profilePic]);

    const handleNav = (route: string, options?: any) => {
        dispatch(clearModalContent());

        if (route === "/logout") {
            onLogout("MANUAL");

            return;
        }

        navigate(route, options);
    };

    const handleNavNewTab = (route: string) => {
        dispatch(clearModalContent());
        const url = `${window.location.origin}${route}`;
        const pathname = window.location.pathname;

        if (route !== pathname) {
            window.open(url, "_blank");
        }
    };

    const handleProfileRedirect = (hash: string) => {
        handleNav(`/profile/${loggedInUser.id}/#${hash}`);
    };

    return (
        !location.pathname.includes('/meeting-info') ? (  <Nav.Item className="header__container">
            <NavDropdown
                id="collasible-nav-dropdown"
                className="user-menu"
                show={dropdownToggle}
                onToggle={() => {
                    setDropdownToggle(!dropdownToggle);
                }}
                title={
                    <div className="header__avatar">
                        <Avatar
                            self={true}
                            userId={id}
                            fullName={full_name}
                            photoUrl={loggedInUser?.profile_pic}
                            hideImage={true}
                        />
                    </div>
                }
            >
                {/* {!user_type?.includes("CLIENT") && ( */}
                    <NavDropdown.Item
                        onClick={() =>
                            handleProfileRedirect('profile')
                        }
                    >
                        <Typography
                            color="color-30"
                            weight={textWeight || "semi-bold"}
                            variant="size-16"
                        >
                            My Profile
                        </Typography>
                    </NavDropdown.Item>
                {/* )} */}

                {(user_type?.includes("CLIENT") ||
                    user_type?.includes("THERAPIST")) && (
                    <NavDropdown.Item
                        onClick={() =>
                            handleProfileRedirect('appointments')
                        }
                    >
                        <Typography
                            color="color-30"
                            weight={textWeight || "semi-bold"}
                            variant="size-16"
                        >
                            Appointments
                        </Typography>
                    </NavDropdown.Item>
                )}

                {(user_type?.includes("SCHEDULER") ||
                    user_type?.includes("PRACTICE_ADMIN")) && (
                    <NavDropdown.Item
                        onClick={() =>
                            handleNav("/therapy/clinician-availability")
                        }
                    >
                        <Typography
                            color="color-30"
                            weight={textWeight || "semi-bold"}
                            variant="size-16"
                        >
                            Availability
                        </Typography>
                    </NavDropdown.Item>
                )}

                {userRole?.toLowerCase() !== "client" && isCalendarEnable === "true" && (
                    <NavDropdown.Item
                        onClick={() => handleNav("/therapy/calendar")}
                    >
                        <Typography
                            color="color-30"
                            weight={textWeight || "semi-bold"}
                            variant="size-16"
                        >
                            Calendar
                        </Typography>
                    </NavDropdown.Item>
                )}

                <NavDropdown.Item
                    onClick={() =>
                        handleNav(
                            `${
                                userRole.toLowerCase() !== "client"
                                    ? "/therapy"
                                    : ""
                            }/settings${
                                userRole.toLowerCase() === "client"
                                    ? "/user"
                                    : ""
                            }`
                        )
                    }
                >
                    <Typography
                        color="color-30"
                        weight={textWeight || "semi-bold"}
                        variant="size-16"
                    >
                        Settings
                    </Typography>
                </NavDropdown.Item>

                <NavDropdown.Item
                    onClick={() => handleNav("/resources/support-options")}
                >
                    <Typography
                        color="color-30"
                        weight={textWeight || "semi-bold"}
                        variant="size-16"
                    >
                        Support
                    </Typography>
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => handleNav("/logout")}>
                    <Typography
                        color="color-30"
                        weight={textWeight || "semi-bold"}
                        variant="size-16"
                    >
                        Log Out
                    </Typography>
                </NavDropdown.Item>
                <NavDropdown.Item>
                    <hr className="header-separator" />
                </NavDropdown.Item>
                <NavDropdown.Item
                    onClick={() => handleNavNewTab("/termsofservice")}
                >
                    <Typography
                        color="color-28"
                        weight={textWeight || "semi-bold"}
                        variant="size-12"
                    >
                        Terms of Service
                    </Typography>
                </NavDropdown.Item>
                <NavDropdown.Item
                    onClick={() => handleNavNewTab("/privacypolicy")}
                >
                    <Typography
                        color="color-28"
                        weight={textWeight || "semi-bold"}
                        variant="size-12"
                    >
                        Privacy Policy
                    </Typography>
                </NavDropdown.Item>
            </NavDropdown>
        </Nav.Item>) : null
    );
};
